// types
import { QuestionSubmissionType } from '@/types/schema';

export enum QuizPlayerActionsEnum {
  JumpToQuestion = 'JUMP_TO_QUESTION',
  PrevQuestion = 'PREV_QUESTION',
  NextQuestion = 'NEXT_QUESTION',
  StartQuiz = 'START_QUIZ',
  SubmitQuiz = 'SUBMIT_QUIZ',
  SaveQuizQuestion = 'SAVE_QUIZ_QUESTION',
  SubmitQuizQuestion = 'SUBMIT_QUIZ_QUESTION',
  SubmitQuestionAndSubmitQuiz = 'SUBMIT_QUESTION_AND_SUBMIT_QUIZ',
  TryAgainQuestion = 'TRY_AGAIN_QUESTION',
}

export interface JumpToQuestionAction {
  type: QuizPlayerActionsEnum.JumpToQuestion;
  payload: { index: number };
}

export interface PrevQuestionAction {
  type: QuizPlayerActionsEnum.PrevQuestion;
}

export interface NextQuestionAction {
  type: QuizPlayerActionsEnum.NextQuestion;
}

export interface StartQuizAction {
  type: QuizPlayerActionsEnum.StartQuiz;
}

export interface SubmitQuizAction {
  type: QuizPlayerActionsEnum.SubmitQuiz;
}

export interface SaveQuizQuestionAction {
  type: QuizPlayerActionsEnum.SaveQuizQuestion;
  payload: {
    submission: Pick<QuestionSubmissionType, 'optionResponse' | 'mtfResponse'>;
    index: number;
  };
}

export interface SubmitQuizQuestionAction {
  type: QuizPlayerActionsEnum.SubmitQuizQuestion;
  payload: { index: number };
}

export interface SubmitQuestionAndSubmitQuizAction {
  type: QuizPlayerActionsEnum.SubmitQuestionAndSubmitQuiz;
  payload: { index: number };
}

export type QuizPlayerActions =
  | JumpToQuestionAction
  | PrevQuestionAction
  | NextQuestionAction
  | StartQuizAction
  | SubmitQuizAction
  | SaveQuizQuestionAction
  | SubmitQuizQuestionAction
  | SubmitQuestionAndSubmitQuizAction;

export type onQuizPlayerAction = (action: QuizPlayerActions, onComplete?: () => void) => void;
